<template>
  <div class="login">
    <form>
      <h1>{{ msg }}</h1>
      <br />
      <span>Username</span>
      <br>
      <input type="username" v-model="inputUsername" />
      <br /><br />
      <span>Password</span>
      <br />
      <input type="password" v-model="inputPassword" />
      <br /><br /><br />
      <button @click="login">Login</button>
      <br />
      <br />
      <ProgressSpinner v-show="loading"/>
    </form>
    <span class="footer">Asytech - 2025</span>
  </div>
</template>

<script>
import { ref } from 'vue';
import axios from 'axios';
import { useRouter } from 'vue-router';
import ProgressSpinner from 'primevue/progressspinner';


export default {
  name: 'LoginView',
  components: { ProgressSpinner },
  setup() {

    var inputUsername = ref("jbbeck")
    var inputPassword = ref("")
    var loading = ref(false)

    const router = useRouter()

    const login = () => {

      let bodyLogin = {
        username: inputUsername.value,
        password: inputPassword.value
      }

      loading.value = true

      axios.post("https://carcharge.asytech.dk/login", bodyLogin)
        .then(res => {
          
          if (res.status === 200) {
            router.push({ path: '/home' })
          }
        }).catch(function (err) {
          console.log(err)
        })
    }

    return {
      login,
      inputPassword,
      inputUsername,
      loading
    }
  },
  props: {
    msg: String,

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
form {
  width: 400px;
  border: thin solid lightgrey;
  border-radius: 10px;
  box-shadow: 2px 2px 2px rgb(198, 198, 198);
  ;
  padding: 10px;
  margin-left: calc(50% - 200px);
  margin-top: 5vh;
  background-color: white;
}

h3 {
  margin: 40px 0 0;
}

button {
  width: 100px;
  height: 30px;
  border-radius: 13px;
  border-width: 1px;
  background-color: transparent;
}

button:hover {
  background-color: rgba(180, 180, 180, 0.104);
}

button:active {
  background-color: rgba(180, 180, 180, 0.732);
}

input {
  border-radius: 13px;
  border-width: 1px;
  height: 25px;
  width: 300px;
  padding-left: 10px;
}

.footer {
  font-size: 10px;
  margin-top: 250px;
}

.p-progressspinner {
  position: absolute;
  margin-left: -50px;
  top: 280px;
}
</style>
